import { useParams } from 'react-router-dom';
import UserRoles from './user-roles';

export default function UserRolesPage() {
  const { userEmail } = useParams() as { userEmail: string };

  return <UserRoles userEmail={userEmail} />;
}
